import { GoogleLogin, LoginButton } from "../components/LoginButton";
import { useTheme } from "../../../context/useThemeContext";
import { LoginField } from "../components/LoginField";
import { PasswordFields } from "../components/PasswordFields";
import { UserLoginState } from "../util/userLoginState";
import { TextDivider } from "../components/TextDivider";
import { ValidateAccountCallback } from "../util/ValidateAccountCallback";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import { useAccountManagementFunctions } from "../hooks/useAccountManagementFunctions";
import RedirectBTN from "../components/RedirectBTN";
import { useFormCooldown } from "../hooks/useFormCooldown";

export default function RegisterView() {
    const { setLoginState } = useAccountManagementStore((state) => state);
    const { registerAccount } = useAccountManagementFunctions();
    const { theme } = useTheme();
    const userLoginState = UserLoginState();
    const { canSubmit, startCooldown } = useFormCooldown(1);

    async function handleCreateAccount() {
        if (!canSubmit) return;

        try {
            const result = await registerAccount(
                userLoginState.email,
                userLoginState.password,
            );

            if (result) {
                setLoginState("checkEmail_CreateAccount");
            } else {
                userLoginState.setEmailErrorMessage("An error occurred");
                startCooldown();
            }
        } catch (error) {
            console.error("Registration error:", error);
            userLoginState.setEmailErrorMessage("Registration failed");
            startCooldown();
        }
    }

    return (
        <form
            id="registerForm"
            className="flex flex-col p-9 pb-7  text-center text-white"
            onSubmit={(e) => {
                e.preventDefault();
                ValidateAccountCallback(
                    userLoginState.setEmailErrorMessage,
                    userLoginState.setPasswordErrorMessage,
                    userLoginState.setVerifyPasswordErrorMessage,
                    userLoginState.email,
                    userLoginState.password,
                    userLoginState.confirmPassword,
                    handleCreateAccount,
                );
            }}
        >
            <b className="mb-4 text-2xl">Create Account</b>
            <LoginField
                fieldTitle="Email"
                fieldID="email"
                fieldType="email"
                value={userLoginState.email}
                onChange={(e) => userLoginState.setEmail(e.target.value.trim())}
                invalidInput={userLoginState.emailErrorMessage !== undefined}
                errorMessage={userLoginState.emailErrorMessage}
            />
            <PasswordFields
                confirmPassword={userLoginState.confirmPassword}
                password={userLoginState.password}
                passwordErrorMessage={userLoginState.passwordErrorMessage}
                setConfirmPassword={userLoginState.setConfirmPassword}
                setPassword={userLoginState.setPassword}
                verifyPasswordErrorMessage={
                    userLoginState.verifyPasswordErrorMessage
                }
            />
            <LoginButton
                type="submit"
                className="my-4 h-[36px] rounded text-sm"
                disabled={!canSubmit}
                style={{
                    backgroundColor: theme.accentColor,
                    opacity: canSubmit ? 1 : 0.5,
                    cursor: canSubmit ? "pointer" : "not-allowed",
                }}
            >
                Register
            </LoginButton>
            <div className="flex w-full cursor-pointer items-center justify-between space-x-2 self-center text-sm">
                <RedirectBTN
                    name="Sign in"
                    onClick={() => {
                        setLoginState("default");
                    }}
                />
            </div>
            <TextDivider middleText="or" />
            <GoogleLogin
                buttonText="Sign up with Google"
                callbackFunction={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            />
        </form>
    );
}
